import { NgxMaskConfig } from 'ngx-mask';

export const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
  showMaskTyped: true
};

